<app-header>
  @if (!disableSend()) {
    <tools-new-send-dropdown></tools-new-send-dropdown>
  }
</app-header>

@if (disableSend()) {
  <bit-callout type="warning" title="{{ 'sendDisabled' | i18n }}">
    {{ "sendDisabledWarning" | i18n }}
  </bit-callout>
}

@if (SendUIRefresh$ | async) {
  <div>
    <tools-send-list
      [sends]="filteredSends()"
      [loading]="loading()"
      [disableSend]="disableSend()"
      [listState]="listState()"
      [searchText]="currentSearchText()"
      (editSend)="editSend($event)"
      (copySend)="onCopySend($event)"
      (deleteSend)="deleteSend($event)"
      (removePassword)="onRemovePassword($event)"
    >
      <div class="tw-mt-4" slot="filters">
        <bit-toggle-group
          [selected]="selectedToggleValue"
          (selectedChange)="onToggleChange($event)"
        >
          <bit-toggle [value]="'all'">{{ "allSends" | i18n }}</bit-toggle>
          <bit-toggle [value]="'text'">{{ "sendTypeText" | i18n }}</bit-toggle>
          <bit-toggle [value]="'file'">{{ "sendTypeFile" | i18n }}</bit-toggle>
        </bit-toggle-group>
      </div>
      @if (!disableSend()) {
        <tools-new-send-dropdown [hideIcon]="true" slot="empty-button"></tools-new-send-dropdown>
      }
    </tools-send-list>
  </div>
} @else {
  <div class="tw-grid tw-grid-cols-12 tw-gap-4">
    <div class="tw-col-span-3">
      <div
        class="tw-border tw-border-solid tw-border-secondary-300 tw-rounded"
        data-testid="filters"
      >
        <div
          class="tw-bg-background-alt tw-border-0 tw-border-b tw-border-solid tw-border-secondary-100 tw-rounded-t tw-px-5 tw-py-2.5 tw-font-medium tw-uppercase"
          data-testid="filters-header"
        >
          {{ "filters" | i18n }}
        </div>
        <div class="tw-p-5" data-testid="filters-body">
          <div class="tw-mb-4">
            <bit-search
              [ngModel]="currentSearchText()"
              (ngModelChange)="searchTextChanged($event)"
              [placeholder]="'searchSends' | i18n"
              appAutofocus
            />
          </div>
          <div class="filter">
            <ul class="filter-options">
              <li class="filter-option" [class.active]="selectedToggleValue === SendFilterType.All">
                <span class="filter-buttons">
                  <button
                    type="button"
                    class="filter-button"
                    appStopClick
                    (click)="onToggleChange(SendFilterType.All)"
                  >
                    <bit-icon name="bwi-grid" fixedWidth></bit-icon>{{ "allSends" | i18n }}
                  </button>
                </span>
              </li>
            </ul>
          </div>
          <div class="filter">
            <div class="filter-heading">
              <h3>{{ "types" | i18n }}</h3>
            </div>
            <ul class="filter-options">
              <li
                class="filter-option"
                [class.active]="selectedToggleValue === SendFilterType.Text"
              >
                <span class="filter-buttons">
                  <button
                    type="button"
                    class="filter-button"
                    appStopClick
                    (click)="onToggleChange(SendFilterType.Text)"
                  >
                    <bit-icon name="bwi-file-text" fixedWidth></bit-icon>{{ "sendTypeText" | i18n }}
                  </button>
                </span>
              </li>
              <li
                class="filter-option"
                [class.active]="selectedToggleValue === SendFilterType.File"
              >
                <span class="filter-buttons">
                  <button
                    type="button"
                    class="filter-button"
                    appStopClick
                    (click)="onToggleChange(SendFilterType.File)"
                  >
                    <bit-icon name="bwi-file" fixedWidth></bit-icon>{{ "sendTypeFile" | i18n }}
                  </button>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="tw-col-span-9">
      <tools-send-list
        [sends]="filteredSends()"
        [loading]="loading()"
        [disableSend]="disableSend()"
        [listState]="listState()"
        [searchText]="currentSearchText()"
        (editSend)="editSend($event)"
        (copySend)="onCopySend($event)"
        (deleteSend)="deleteSend($event)"
        (removePassword)="onRemovePassword($event)"
        [hideSearchBar]="true"
      >
        @if (!disableSend()) {
          <tools-new-send-dropdown [hideIcon]="true" slot="empty-button"></tools-new-send-dropdown>
        }
      </tools-send-list>
    </div>
  </div>
}
